import { BaseComponent } from '../base.component';
import defaultHtml from './tooltip.component.hbs';

export class TooltipComponent extends BaseComponent<string> {
    protected override bindEvent = undefined;
    protected override customTemplatePropertyName = 'tooltip';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        const text = this.getAttribute('text') as string | null;

        if (!text) {
            return '';
        }

        const html = template({
            text: text
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelector('[hawksearch-tooltip]')?.addEventListener('mouseover', (event: Event) => {
            const element = event.currentTarget as HTMLElement;
            const contentElement = this.shadowRoot?.querySelector('[hawksearch-tooltip-content]') as HTMLElement;

            if (!contentElement) {
                return;
            }

            contentElement.style.removeProperty('top');
            contentElement.style.removeProperty('right');

            const windowWidth = window.innerWidth;
            const boundingRect = element.getBoundingClientRect();
            const rightPosition = boundingRect.x + boundingRect.width;
            const maxWidth = 350;
            const margin = 20;

            contentElement.style.top = `${boundingRect.top}px`;

            if (windowWidth - rightPosition < maxWidth + margin) {
                contentElement.style.right = `${margin}px`;
            }
        });
    }
}
